/* eslint-disable complexity */
import { Box, Stack, Switch, Typography, useTheme } from '@mui/material';
import { CustomSwitch } from 'components/Inputs';
import { getIndicationColor } from 'constants/ui.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { beneficiaryRiskType } from './BottomSection/tables.types';

export const CustomCompanySwitch = (props: { closed: boolean }) => {
	const theme = useTheme();
	const { closed } = props;
	return (
		<CustomSwitch
			checked={closed ? false : true}
			theme={theme}
			styleObj={{
				width: closed ? '85px' : '68px',
				'& .MuiButtonBase-root': {
					transform: closed ? 'translateX(57px)' : 'translateX(41px)',
					cursor: 'default',
					'&:before': {
						content: closed ? "'לא פעיל'" : "'פעיל'",
						transform: closed ? 'translate(-40px)' : 'translate(-35px)',
						position: 'absolute',
						color: closed ? theme.palette.root.orange : theme.palette.root.forestGreen,
						width: 'max-content',
					},
				},
				'& .Mui-checked+.MuiSwitch-track': {
					background: closed ? theme.palette.root.lightOrange_2 : theme.palette.root.lightTeal,
				},
			}}
		>
			<Switch checked={true} />
		</CustomSwitch>
	);
};
export const RiskLevel = (props: { riskLevel: any; noLabel?: boolean }) => {
	const t = useAppSelector(selectTranslations);
	const { riskLevel, noLabel } = props;
	const pagePrefix = 'page.customerAccounts.';
	const basicDataPrefix = `${pagePrefix}basicData.`;

	const getRiskSign = (risk: string) => {
		switch (risk) {
			case beneficiaryRiskType.LOW:
			case beneficiaryRiskType.MEDIUM:
				return 'url("/icons/switch_on.svg")';
			case beneficiaryRiskType.HIGH:
			case beneficiaryRiskType.VERY_HIGH:
				return 'url("/icons/warning-orange.svg")';
			default:
				break;
		}
	};

	return (
		<Stack spacing={1}>
			<Stack spacing={1} direction="row" alignItems="center" alignSelf="center">
				<Box
					sx={{
						width: '16px',
						height: '16px',
						borderRadius: '50%',
						position: 'relative',
						backgroundImage: getRiskSign(riskLevel),
						backgroundColor: getIndicationColor(riskLevel),
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						backgroundBlendMode: 'hard-light',
					}}
				></Box>
				<Typography
					variant={!noLabel ? 'h4' : 'body1'}
					sx={{
						fontWeight: 700,
						color: getIndicationColor(riskLevel),
					}}
				>
					{riskLevel
						? t(`${basicDataPrefix}riskLevel.${riskLevel}`)
						: t(`${basicDataPrefix}riskLevel.unKnown`)}
				</Typography>
			</Stack>
			{!noLabel && <Typography variant="body">{t(`${basicDataPrefix}riskLevel`)}</Typography>}
		</Stack>
	);
};
